import { Routes } from '@angular/router';
import { ErrorPageComponent } from '@feature/error-page/error-page.component';
import { PreviewContentComponent } from '@feature/preview-management/components/preview-content/preview-content.component';
import PreviewPageComponent from '@feature/preview-management/components/preview-page/preview-page.component';
import { PrintPageComponent } from '@feature/print-management/components/print-page/print-page.component';
import { ThemePreviewComponent } from '@feature/theme-management/components/theme-preview/theme-preview.component';
import { CanDeactivateGuard } from './core/guards/can-deactivate.guard';
import { GdprPageComponent } from './feature/gdpr-page-management/component/gdpr-page/gdpr-page.component';
import { GotoPageComponent } from './feature/goto-page-management/components/goto-page/goto-page.component';
import { InformationPageComponent } from './feature/information-page-mangement/components/information-page/information-page.component';
import { InvitationComponent } from './feature/invitation-management/component/invitation/invitation.component';
import { LanguagePageComponent } from './feature/language-management/componenets/language-page/language-page.component';
import { PasswordPageComponent } from './feature/password-management/components/password-page/password-page.component';
import { StartOverComponent } from './feature/start-over-management/components/start-over/start-over.component';
import { SurveyPageComponent } from './feature/survey-management/components/survey-page/survey-page.component';
import { EditComponent } from "@feature/edit-management/edit/edit.component";

export const routes: Routes = [
  {
    path: 'edit/:responseId',
    component: EditComponent,
    canDeactivate: [CanDeactivateGuard],
    data: {
      queryParams: [
        'sid',
        'userId'
      ],
    }
  },
  {
    path: 'invitation/:invitationId',
    component: InvitationComponent,
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path: 'bylink/:questId',
    component: InvitationComponent,
    canDeactivate: [CanDeactivateGuard],
    data: {
      queryParams: ['language'],
    },
  },
  {
    path: 'print/:questId',
    component: PrintPageComponent,
    data: {
      queryParams: ['showConditions', 'language'],
    },
  },
  {
    path: ':responseId/information',
    component: InformationPageComponent,
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path: ':responseId/view/:stateId',
    component: SurveyPageComponent,
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path: ':responseId/choose-language',
    component: LanguagePageComponent,
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path: ':responseId/gdpr',
    component: GdprPageComponent,
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path: ':responseId/password',
    component: PasswordPageComponent,
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path: ':responseId/start-over',
    component: StartOverComponent,
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path: ':responseId/goto-page',
    component: GotoPageComponent,
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path: 'preview/:questId',
    component: PreviewPageComponent,
    canDeactivate: [CanDeactivateGuard],
    data: {
      queryParams: ['mode', 'language'],
    },
  },
  {
    path: 'preview-content/:questId',
    component: PreviewContentComponent,
    canDeactivate: [CanDeactivateGuard],
    data: {
      queryParams: [
        'mode',
        'language',
        'questionId',
        'showConditions',
        'pageName',
        'sessionId'
      ],
    },
  },
  {
    path: 'theme-preview',
    component: ThemePreviewComponent,
    canDeactivate: [CanDeactivateGuard],
    data: {
      queryParams: ['themeParameters'],
    },
  },
  {
    path: 'error-page/:code',
    component: ErrorPageComponent,
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path: '**',
    component: ErrorPageComponent,
    canDeactivate: [CanDeactivateGuard],
  },
];
